// extracted by mini-css-extract-plugin
export default {"container":"Popover--container--81d1c8","autoWidth":"Popover--autoWidth--32418e","content":"Popover--content--e6f431","closeIcon":"Popover--closeIcon--599045"};